import { hasVsmAccess } from './vsm_access'

export function isFeatureEnabled(value) {
  if (value == null || value === '') return false
  if (typeof value === 'boolean') return value
  if (typeof value === 'number') return value !== 0

  const normalized = String(value).trim().toLowerCase()
  if (normalized === 'false' || normalized === '0' || normalized === 'no') return false
  return normalized === 'true' || normalized === '1' || normalized === 'yes'
}

export function hasAlertsAccess(features) {
  const f = features || {}
  return isFeatureEnabled(f.alerts_enabled)
}

export function hasAlertsHistoryAccess(features) {
  return hasAlertsAccess(features) || hasVsmAccess(features)
}

const GROUP_MESSAGE_ROLES = new Set(['admin', 'customer-admin', 'tbn-admin', 'dispatch', 'manager'])

export function hasGroupMessageAccess(user) {
  if (!user) return false
  if (!GROUP_MESSAGE_ROLES.has(user.role)) return false
  const features = (user.features && user.features[user.tenant]) || {}
  return hasAlertsAccess(features)
}

export function groupMessageRouteName(user) {
  if (!user) return 'group_message_sender'
  return user.types && user.types[user.tenant] === 'TBN'
    ? 'group_message_sender_tbn'
    : 'group_message_sender'
}
